import { createSelector } from 'reselect';

import {
  // Features
  featuresIsPremiumSelector,
  featuresHasCoachProfileSelector,
  featuresIsCraUserSelector,
  featuresIsSeatManagerAdminSelector,
  featuresIsJobsPosterSelector,
  featuresIsBrandPageCollaboratorSelector,
  featuresIsAdmasterUserSelector,
  featuresIsBrandManageEditorSelector,
  // Navigation
  premiumUpsellPersonalSelector,
  proJobsPersonalSelector,
  proBusinessMemberPersonalSelector,
  benefitsPersonalSelector,
  coachProfilePersonalSelector,
  xtmPersonalSelector,
  seatManagerAdminPersonalSelector,
  jobsPosterPersonalSelector,
  brandPagePersonalSelector,
  brandManagerEditorSelector,
  admasterUserPersonalSelector,
  navigationSettingsPersonalSelector,
  invoicesPersonalSelector,
  navigationLogoutPersonalSelector,
} from '../selectors';

export default createSelector(
  featuresIsPremiumSelector,
  featuresHasCoachProfileSelector,
  featuresIsCraUserSelector,
  featuresIsSeatManagerAdminSelector,
  featuresIsJobsPosterSelector,
  featuresIsBrandPageCollaboratorSelector,
  featuresIsAdmasterUserSelector,
  featuresIsBrandManageEditorSelector,
  premiumUpsellPersonalSelector,
  proJobsPersonalSelector,
  proBusinessMemberPersonalSelector,
  benefitsPersonalSelector,
  coachProfilePersonalSelector,
  xtmPersonalSelector,
  seatManagerAdminPersonalSelector,
  jobsPosterPersonalSelector,
  brandPagePersonalSelector,
  brandManagerEditorSelector,
  admasterUserPersonalSelector,
  navigationSettingsPersonalSelector,
  invoicesPersonalSelector,
  navigationLogoutPersonalSelector,
  (
    isPremium,
    hasCoachProfile,
    isCraUser,
    isSeatManagerAdmin,
    isJobsPoster,
    isBrandPageCollaborator,
    isAdmasterUser,
    isBrandManageEditor,
    premiumUpsellPersonal,
    proJobsPersonal,
    proBusinessMemberPersonal,
    benefitsPersonal,
    coachProfilePersonal,
    xtmPersonal,
    seatManagerAdminPersonal,
    jobsPosterPersonal,
    brandPagePersonal,
    brandManagerEditor,
    admasterUserPersonal,
    settingsPeronal,
    invoicesPersonal,
    logoutPersonal
  ) => ({
    isPremium,
    links: [
      premiumUpsellPersonal,
      proJobsPersonal,
      proBusinessMemberPersonal,
      benefitsPersonal,
      hasCoachProfile && coachProfilePersonal,
      isCraUser && xtmPersonal,
      isSeatManagerAdmin && seatManagerAdminPersonal,
      isJobsPoster && jobsPosterPersonal,
      isBrandPageCollaborator && brandPagePersonal,
      isBrandManageEditor && brandManagerEditor,
      isAdmasterUser && admasterUserPersonal,
      settingsPeronal,
      invoicesPersonal,
      logoutPersonal,
    ].filter(Boolean),
  })
);
